import { MutationTree } from 'vuex'
import { SceneState } from './types'

export const mutations: MutationTree<SceneState> = {
  syncState(state, payload) {
    state = { ...payload }
  },
}
